import React, { useEffect } from "react";
import { Carousel } from "primereact/carousel";
import { TestimonialCard } from "../../shared/components/CustomCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchOurClients } from "../../store/slices/contentSlice";

const OurClients = ({ }) => {
    const dispatch = useDispatch()
    const { ourClients } = useSelector((state) => state.content)

    useEffect(() => {
        dispatch(fetchOurClients())
    }, [])

    const responsiveOptions = [
        {
            breakpoint: "1400px",
            numVisible: 3,
            numScroll: 1,
        },
        {
            breakpoint: "1199px",
            numVisible: 3,
            numScroll: 1,
        },
        {
            breakpoint: "767px",
            numVisible: 2,
            numScroll: 1,
        },
        {
            breakpoint: "575px",
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const TestimonialTemplate = (item) => {
        return (
            <TestimonialCard
                src={item?.author?.image}
                title={item?.title}
                detail={item?.description}
                clientName={item?.author?.name}
                designation={item?.author?.role}
            />
        );
    };

    return (
        <div className="py-8 bg-gray-light">
            <div className="container mb-7">
                <h2 className="heading text-4xl text-center mb-4 rubik">
                    What Our Client Says
                </h2>
                {/* <p className="text-gray-color text-center text-lg">
                    Lorem Ipsum is simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy text
                    ever since the 1500s
                  </p> */}
                <div className="grid bg-white mt-7">
                    <Carousel
                        className="w-full testimonial-container"
                        value={ourClients}
                        numVisible={3}
                        numScroll={1}
                        responsiveOptions={responsiveOptions}
                        itemTemplate={TestimonialTemplate}
                        showIndicators={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default OurClients